export default {
  PARTNERS: 'PARTNERS',
  BENEFICIARIES: 'BENEFICIARIES',
  INVESTORS: 'INVESTORS',
  DIRECTORS: 'DIRECTORS',
  ALL: 'ALL',
  CUSTOM: 'CUSTOM',
};
